import * as moment from 'moment';
import * as React from 'react';
import { daysOfWeek, monthEdges } from './dateUtils';
import Day from './Day';

interface Props {
    date: moment.Moment;
    month: moment.Moment;
    weekNumberFormat?: string;
    weekdayFormat?: string;
    selected: moment.Moment[];
    newlySelected: moment.Moment[];
    onToggle: (day: moment.Moment) => void;
}

export default class Week extends React.PureComponent<Props> {
    public static defaultProps = {
        weekNumberFormat: 'w',
        weekdayFormat: 'dd'
    };

    constructor(props: Props) {
        super(props);
    }

    public render() {
        const { date, month, weekNumberFormat, newlySelected, selected, onToggle } = this.props;
        const checkDate = date.isBefore(month) ? date.endOf('week') : date.startOf('week');

        const daysNotInMonth = monthEdges(checkDate);
        return (
            <div key="days" className={'rc-Week-week'}>
                <div key="weekNumber" className={'rc-Week-number'}>
                    {date.format(weekNumberFormat)}
                </div>
                <div className={'rc-Week-days'}>
                    {daysOfWeek(date).map((day, i) => {
                        const outside = Boolean(daysNotInMonth.find(edge => day.isSame(edge, 'day')));
                        const over = day.isBefore( moment() )
                        return (
                            <Day
                                key={`day-${i}`}
                                date={day}
                                disabled={outside || over}
                                selected={selected}
                                newlySelected={newlySelected}
                                onToggle={onToggle}
                            />
                        );
                    })}
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/calendar/Week.tsx